import { fork, take } from "redux-saga/effects";

import actionTypes from "../actionTypes";


function* getRaffles(): any {
 /* const storeMission = yield select(getGameBoxMissionActualData);
  const raffleMission = !!storeMission && storeMission.filter((mission: { prize: { type: string; } }) => mission.prize?.type === 'raffleTicket');

  if (raffleMission.length) {
    try {
      const headers = {};
      const token = yield select(getToken);
      const response = yield call(apiGet, 'REACT_APP_GAMEBOX_URL', apiRoutes.GET_ACTIVE_JACKPOTS, { token }, headers);

      const transformData = transformRaffleData(response?.data?.result?.raffles[0]);
      yield put(successGameBoxRaffle(transformData));

    } catch (error) {
      console.log('getRaffles failure', error);
      yield put(failGameBoxRaffle());
    }
  }*/
}

export default function* watchGameBoxRaffleRequest() {
  while (true) {
    yield take([
      actionTypes.GAME_BOX_MISSION_SUCCESS,
      actionTypes.GAME_BOX_JACKPOT_REQUEST
    ]);
    yield fork(getRaffles);
  }
};
